import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';

import HelpArticle from 'help/components/article';
import { fetchAllCategoriesIfNeeded } from 'help/ducks/categories';
import { fetchArticleIfNeeded, voteArticle } from 'help/ducks/article';

HelpArticle.need = [
  params => fetchArticleIfNeeded(params.articleSlug),
  fetchAllCategoriesIfNeeded
];

export function mapStateToProps({ help: { categories, article } }) {
  return {
    categories,
    article,
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { articleSlug } = params;
  const actions = {
    fetchArticleIfNeeded: partial(fetchArticleIfNeeded, articleSlug),
    fetchAllCategoriesIfNeeded,
    upvote: partial(voteArticle, articleSlug, true),
    downvote: partial(voteArticle, articleSlug, false),
  };

  return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpArticle));



// WEBPACK FOOTER //
// ./help/containers/article.js